import { Features } from 'constants/feature_names'
import PropTypes from 'prop-types'

const flagShape = {}

Object.keys(Features).forEach(key => {
  flagShape[key] = PropTypes.bool
})

export const flagDataTypes = PropTypes.shape(flagShape)
